import { render, staticRenderFns } from "./AccesibilityContent.vue?vue&type=template&id=1b9cda42&scoped=true"
import script from "./AccesibilityContent.vue?vue&type=script&lang=js"
export * from "./AccesibilityContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9cda42",
  null
  
)

export default component.exports